import { http } from "@/lib/api";

function toArray(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data?.results)) return payload.data.results;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.results)) return payload.results;
  return [];
}

function normalizeOption(item, keys) {
  const id = keys.id.map((key) => item?.[key]).find((value) => value !== undefined && value !== null && value !== "");
  const label = keys.label
    .map((key) => item?.[key])
    .find((value) => typeof value === "string" && value.trim().length > 0);

  if (!id || !label) return null;

  return {
    id: String(id),
    label: label.trim(),
    raw: item,
  };
}

async function fetchOptions(path, keys) {
  const response = await http.get(path);
  return toArray(response?.data).map((item) => normalizeOption(item, keys)).filter(Boolean);
}

export async function fetchGothras() {
  return fetchOptions("/shared/gothras", {
    id: ["gothraId", "id", "value"],
    label: ["name", "nativeName", "gothra", "gothraName", "displayName", "label"],
  });
}

export async function fetchNakshatras() {
  return fetchOptions("/shared/nakshatras", {
    id: ["nakshatraId", "id", "value"],
    label: ["name", "nativeName", "nakshatra", "nakshatraName", "displayName", "label"],
  });
}

export async function fetchZodiacSigns() {
  return fetchOptions("/shared/zodiac-signs", {
    id: ["zodiacSignId", "id", "value"],
    label: ["name", "nativeName", "zodiacSign", "zodiacSignName", "displayName", "label"],
  });
}
